import styled from 'styled-components'

export const CalendarWrapper = styled.div`
  .react-calendar {
    width: 100%;
    border-color: #f5f5f5;
    font-family: ${props => props.theme.fontFamily};

    button {
      font-family: ${props => props.theme.fontFamily};
      height: 25px;
      line-height: 0.75;

      &:hover {
        background: initial;
      }

      &.event {
        background: #efefef;
        color: #000;
      }

      &.react-calendar__tile--active {
        color: #000;
        background: #fff;
      }

      &:focus {
        background: ${props => props.theme.primaryColor};
        color: #fff;
      }
    }

    .react-calendar__month-view__weekNumbers .react-calendar__tile {
      padding: 9px 0px 1px 0;
    }

    .react-calendar__month-view__weekdays__weekday,
    .react-calendar__month-view__days__day--weekend {
      color: ${props => props.theme.primaryFontColor};
      font-weight: normal;
    }
  }
`
